import React, { useContext, useState } from 'react';
import {
  getButtonStyle,
  largeButtons,
} from "../../style/js-style/common/buttonStyle.js";
import useMediaQuery from "@mui/material/useMediaQuery";
import EAIcon from './EAIcon';
import { Context } from '../../states/Store';
import { useTheme } from '@mui/material';

/**
 *  Return generic button with style
 *
 * @param onClick action
 * @param content text
 * @param size xs | small | regular | large
 * @param colorVariant primary | error | secondary | success | warning
 * @param outFilled boolean
 * @param disabled boolean
 * @param customStyle style
 * @param borderless button like link style
 * @param hoverContent
 * @param validateLoading ajoute un loader sur le bouton
 * @param otherProps override props
 * @returns {JSX.Element}
 * @constructor
 */
function EAButton({
  onClick,
  content,
  size = "regular",
  colorVariant = "primary",
  outFilled,
  disabled,
  customStyle,
  borderless,
  hoverContent = null,
  validateLoading = false,
  ...otherProps
}) {
  const [state] = useContext(Context);
  const [isHovered, setIsHovered] = useState(false);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("inch16"));
  const style = getButtonStyle(size, colorVariant, outFilled, (disabled || validateLoading), borderless, state.personalization, theme );

  return (
    <button
      style={{
        ...style,
        ...(isHovered && style.hover),
        ...(matches && largeButtons[size]),
        ...(borderless && style.borderless),
        ...(customStyle !== null && customStyle),
      }}
      disabled={disabled || validateLoading}
      {...(!disabled && {
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false),
        onClick: onClick,
      })}
      {...otherProps}
    >
      <span style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
      >
        {validateLoading &&
          <EAIcon
            icon={"loop_white"}
            style={{
              marginRight: "10px",
              animation: "spin 2s ease-out infinite",
            }}
          />
        }
        {isHovered && hoverContent ? hoverContent : content}
      </span>
      </button>
  );
}

export default EAButton;
